export default __webpack_public_path__ + "static/media/utp-portal.f0979d74.svg";